module.exports = __webpack_public_path__ + "static/media/icon-wallet-arrow.adf11460.svg";